import React from "react";
import "./ListPageHeader.css";

type Props = {
  /** Page title, e.g. "Varianti". */
  title: string;
  /** Optional short descriptor under the title. */
  subtitle?: string;
  /** Optional item count shown as a pill next to the title. */
  count?: number;
  /** Primary action(s) — typically the "Aggiungi …" button. */
  actions?: React.ReactNode;
  /** Search box + filter selects. They wrap responsively. */
  children?: React.ReactNode;
};

// Shared header for the catalog/list pages. Replaces the old per-page
// `<Row><h4/>…<button/></Row>` + `<hr/>` with one athletic, responsive header:
// oxblood-accented title, optional count pill, a filter cluster that wraps on
// mobile (so pages no longer duplicate a separate desktop/mobile row), and the
// primary action pinned to the right.
export default function ListPageHeader({
  title,
  subtitle,
  count,
  actions,
  children,
}: Props) {
  return (
    <header className="list-page-header">
      <div className="list-page-header-row">
        <div className="list-page-titlewrap">
          <span className="list-page-tick" aria-hidden="true" />
          <div>
            <div className="list-page-titleline">
              <h4 className="list-page-title">{title}</h4>
              {count != null && (
                <span className="list-page-count">{count}</span>
              )}
            </div>
            {subtitle && <p className="list-page-subtitle">{subtitle}</p>}
          </div>
        </div>
        {actions && <div className="list-page-actions">{actions}</div>}
      </div>
      {children && <div className="list-page-filters">{children}</div>}
    </header>
  );
}
